<template>
	<div class="home">
		<div class="sdgdsfbxcvbcx"><img src="../assets/logos.png" alt=""></div>
		<div class="ctj">
			<el-input placeholder="请输入预约号" v-model="fs"></el-input>
			<el-button type="primary" @click="fscx">分数查询</el-button>
		</div>
		<div class="sdsd" v-if="xsxs">
			<h4>您好{{chenj[0]?.datas}}!</h4>
			<el-table :data="chenj" style="width: 50%">
				<el-table-column prop="HDachievement" label="隐患排查" width="100">
				</el-table-column>
				<el-table-column prop="PTachievement" label="实训考试" width="100">
				</el-table-column>
				<el-table-column prop="lengths" label="最终成绩" width="100">
				</el-table-column>
			</el-table>
		</div>
		<div v-if="xsxs">
			<h4>错题集</h4>
			<div class="asdgsdffdfc" v-for="(it1, id1) in ctj" :key="id1">
				<div class="casdasd">{{it1.mkm}}</div>
				<div v-for="(it2, id2) in it1.tm" :key="id2">
					<h5>{{it2.ask}}</h5>
					<p v-if="it2.A">A: {{it2.A}}</p>
					<p v-if="it2.B">B: {{it2.B}}</p>
					<p v-if="it2.C">C: {{it2.C}}</p>
					<p v-if="it2.D">D: {{it2.D}}</p>
					<p v-if="it2.answer == 1">正确答案A</p>
					<p v-else-if="it2.answer == 2">正确答案B</p>
					<p v-else-if="it2.answer == 3">正确答案C</p>
					<p v-else>正确答案D</p>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fs: '',
				chenj: [],
				xsxs: false,
				ctj: []
			};
		},
		created() {
			let fs = this.$route.query.fs
			if (fs) {
				this.fs = fs
				this.fscx()
			}
		},

		methods: {
			async fscx() {
				const {
					data: res
				} = await this.$http.get(`fscxww/${this.fs}`)
				if (res.length !== 0) {
					this.chenj = res
				}
				console.log(res);
				const {
					data: ctjres
				} = await this.$http.get(`analysis/${this.fs}`)
				for (const key in ctjres) {
					var ctmk = {
						tm: [],
						mkm: ''
					}
					if (ctjres[key].Isid.length !== 0) {
						// console.log(ctjres[key].uname);
						ctmk.mkm = ctjres[key].uname
						for (const kone in ctjres[key].Isid) {
							const {
								data: kaoti
							} = await this.$http.get(`subjectss/${ctjres[key].Isid[kone]}`)
							ctmk.tm.push(kaoti[0])
						}
					}
					if (ctmk.mkm != "") {
						this.ctj.push(ctmk)
					}
				}
				console.log(this.ctj);
				this.xsxs = true
			}
		}
	};
</script>

<style lang="less" scoped>
	h4 {
		padding-left: 30%;
	}

	.asdgsdffdfc {
		padding-left: 30%;
	}

	.ctj {
		width: 50%;
		margin: auto;
		margin-top: 10%;
	}

	/deep/.el-input {
		margin-right: 20%;
	}

	/deep/.el-button {
		margin-left: 20%;
	}

	.sdsd {
		width: 100%;
		margin-left: 50%;
		transform: translateX(-50%);
	}

	/deep/.el-table {
		margin-left: 50%;
		transform: translateX(-50%);
	}

	.casdasd {
		margin-top: 70px;
	}

	/deep/.el-table td,
	.el-table th.is-leaf {
		display: block;
		// border-bottom: 0 !important;
	}

	/deep/.el-table th {
		display: block !important;
	}

	/deep/.el-table {
		display: flex;
	}

	/deep/.el-table::before {
		height: 0;
	}

	.sdgdsfbxcvbcx {
		width: 170px;
		position: fixed;
		bottom: 30px;
		right: 10px;
		font-size: 40px;
		color: #ccc;
		z-index: -1;

		img {
			width: 100%;
		}
	}
</style>
